import React from "react";
import TabBarComponent from "../components/TabBar";
// import { Outlet } from "react-router-dom";

function TabBar() {
  return (
    <>
      <TabBarComponent />
    </>
  );
}

export default TabBar;
